import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from '@99designs/common/components/Icon';
import DropdownMenu from 'components/DropdownMenu';

export default class ShareButtonDropdownMenu extends React.Component {
    constructor(props) {
        super(props);
        this.getDropdownItemData = this.getDropdownItemData.bind(this);
        this.onAction = this.onAction.bind(this);
    }

    onAction(data) {
        const shareData = this.props.design.shareData;
        const url = shareData.find(datum => datum.name === data.key).shareUrl;

        window.open(url, '_blank');
    }

    getShareIcon(shareDatum) {
        return (
            <span className="menu__item__action__icon">
                <Icon variations={[`icon ${shareDatum.iconVariation}`]} />
            </span>
        );
    }

    getDropdownItemData() {
        const shareData = this.props.design.shareData;

        return shareData.map(function(shareDatum) {
            return {
                label: this.context.intl.formatMessage({ id: shareDatum.name }),
                key: shareDatum.name,
                icon: this.getShareIcon(shareDatum),
            };
        }, this);
    }

    render() {
        return (
            <DropdownMenu itemData={this.getDropdownItemData()} onSelect={this.onAction}>
                <button className="icon-button icon-button--on-white icon-button--offset-right">
                    <span className="icon icon--share-1" />
                </button>
                <button className="button button--link">
                    {this.context.intl.formatMessage({ id: 'share' })}
                </button>
            </DropdownMenu>
        );
    }
}

ShareButtonDropdownMenu.contextTypes = {
    intl: PropTypes.object.isRequired,
};

ShareButtonDropdownMenu.propTypes = {
    design: PropTypes.any.isRequired, // eslint-disable-line react/forbid-prop-types
};



// WEBPACK FOOTER //
// ./src/js/apps/ddo/components/ShareButtonDropdownMenu.jsx